module.exports = __webpack_public_path__ + "static/media/bg.b240ebe6.svg";